// // import React, { useState } from 'react';
// // import { Box, CssBaseline, useMediaQuery, useTheme } from '@mui/material';
// // import { Navigate, Route, Routes } from 'react-router-dom';
// // import { FaUsersGear } from 'react-icons/fa6';

// // import Sidebar from '../SideNav/Sidebar'; // Adjust the path as necessary
// // import Header from '../SideNav/Header'; // Adjust the path as necessary
// // import Dashboard from '../../Pages/Dashboard/Dashboard'; // Adjust the path as necessary
// // import AllUserList from '../../Pages/OperatorRegistration/AllUserList';
// // import ContentManagement from '../../Pages/ContentManagement/Home/ContentManagement';
// // import StakeNowContentManagement from '../../Pages/ContentManagement/StakeNow/StakeNowContentManagement';
// // import PurchaserList from '../../Pages/OperatorRegistration/PurchaserList';
// // import ReferrerList from '../../Pages/OperatorRegistration/ReferrerList';
// // import FinanicalConsultantList from '../../Pages/OperatorRegistration/FinanicalConsultantList';
// // import UserRole from '../../Pages/Masters/UserRole/UserRole';
// // import UserList from '../../Pages/Masters/UserList/UserList';
// // import ProtectedRoute from '../../Pages/PrivateRoute';
// // import RegistrationApproval from '../../Pages/Management/RegistrationApproval/RegistrationApproval';

// // const Layout = () => {
// //   const [isSidebarOpen, setSidebarOpen] = useState(false);
// //   const [headerName, setHeaderName] = useState("")
// //   const theme = useTheme();
// //   const isMobile = useMediaQuery(theme.breakpoints.down("md"));
// //   const [profileData, setProfileData] = useState([]); // Assuming profile data will be set later

// //   // Toggles sidebar visibility on menu click
// //   const handleMenuClick = () => {
// //     setSidebarOpen(!isSidebarOpen);
// //   };

// //   // Handles profile click event (add functionality later if needed)
// //   const handleProfileClick = () => {
// //     // Add profile-related logic here
// //   };

// //   return (
// //     <Box sx={{ display: 'flex', minHeight: '100vh' }}>
// //       <CssBaseline />

// //       {/* Sidebar Component */}
// //       <Sidebar
// //         open={isSidebarOpen}
// //         onClose={() => setSidebarOpen(false)}
// //       />

// //       <Box
// //         sx={{
// //           flexGrow: 1,
// //           display: 'flex',
// //           flexDirection: 'column',
// //           justifyContent: 'flex-start',
// //         }}
// //       >
// //         {/* Header Component */}
// //         <Header
// //           edit={false}
// //           onMenuClick={handleMenuClick}
// //           handleProfileClick={handleProfileClick}
// //           isMobile={isMobile}
// //           setSidebarOpen={setSidebarOpen}
// //           isSidebarOpen={isSidebarOpen}
// //           icon={<FaUsersGear />}
// //           headerName={headerName}
// //         />

// //         <Box
// //           component="main"
// //           sx={{
// //             flexGrow: 1,
// //             p: 2.5,
// //             backgroundColor: '#F7F7F7',

// //           }}
// //         >

// //           <Routes>
// //             <Route path="/dashboard" element={<Dashboard />} />

// //             {/* Protected routes */}
// //             <Route
// //               path="/registration-approval"
// //               element={
// //                 <ProtectedRoute permission="view_registration_approval">
// //                   <RegistrationApproval />
// //                 </ProtectedRoute>
// //               }
// //             />
// //             <Route
// //               path="/user-management"
// //               element={
// //                 <ProtectedRoute permission="view_user_management">
// //                   <AllUserList />
// //                 </ProtectedRoute>
// //               }
// //             />
// //             <Route
// //               path="/reports"
// //               element={
// //                 <ProtectedRoute permission="view_reports">
// //                   <UserRole />
// //                 </ProtectedRoute>
// //               }
// //             />
// //             <Route path="*" element={<Navigate to="/dashboard" />} />
// //           </Routes>

// //           {/* Main Content */}
// //           {/* <Routes>
// //             <Route
// //               path="/"
// //               element={<ProtectedRoute element={<Dashboard setHeaderName={setHeaderName} />} />}
// //             />
// //             <Route
// //               path="/alluserlist"
// //               element={<ProtectedRoute element={<AllUserList />} />}
// //             />
// //             <Route
// //               path="/purchaserlist"
// //               element={<ProtectedRoute element={<PurchaserList />} />}
// //             />
// //             <Route
// //               path="/referrerlist"
// //               element={<ProtectedRoute element={<ReferrerList />} />}
// //             />
// //             <Route
// //               path="/finanicalconsultantlist"
// //               element={<ProtectedRoute element={<FinanicalConsultantList />} />}
// //             />
// //             <Route
// //               path="/ContentManagement-home"
// //               element={<ProtectedRoute element={<ContentManagement />} />}
// //             />
// //             <Route
// //               path="/ContentManagement-stakenow"
// //               element={<ProtectedRoute element={<StakeNowContentManagement />} />}
// //             />
// //             <Route
// //               path="/user-role"
// //               element={<ProtectedRoute element={<UserRole />} />}
// //             />
// //             <Route
// //               path="/user-list"
// //               element={<ProtectedRoute element={<UserList />} />}
// //             />
// //              <Route
// //               path="/Registration-Approval"
// //               element={<ProtectedRoute element={<RegistrationApproval />} />}
// //             />

// //         </Routes> */}
// //         </Box>

// //         {/* Footer Component (Optional) */}
// //         {/* <FooterPage /> */}
// //       </Box>
// //     </Box >
// //   );
// // };

// // export default Layout;

// import React, { useState } from 'react';
// import { Box, CssBaseline, useMediaQuery, useTheme } from '@mui/material';
// import { Navigate, Route, Routes } from 'react-router-dom';
// import { FaUsersGear } from 'react-icons/fa6';

// import Sidebar from '../SideNav/Sidebar'; // Adjust the path as necessary
// import Header from '../SideNav/Header'; // Adjust the path as necessary
// import Dashboard from '../../Pages/Dashboard/Dashboard'; // Adjust the path as necessary
// import AllUserList from '../../Pages/OperatorRegistration/AllUserList';
// import ContentManagement from '../../Pages/ContentManagement/Home/ContentManagement';
// import StakeNowContentManagement from '../../Pages/ContentManagement/StakeNow/StakeNowContentManagement';
// import PurchaserList from '../../Pages/OperatorRegistration/PurchaserList';
// import ReferrerList from '../../Pages/OperatorRegistration/ReferrerList';
// import FinanicalConsultantList from '../../Pages/OperatorRegistration/FinanicalConsultantList';
// import UserRole from '../../Pages/Masters/UserRole/UserRole';
// import UserList from '../../Pages/Masters/UserList/UserList';
// import ProtectedRoute from '../../Pages/PrivateRoute';
// import RegistrationApproval from '../../Pages/Management/RegistrationApproval/RegistrationApproval';

// const Layout = () => {
//   const [isSidebarOpen, setSidebarOpen] = useState(false);
//   const [headerName, setHeaderName] = useState("")
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));
//   const [profileData, setProfileData] = useState([]); // Assuming profile data will be set later

//   // Toggles sidebar visibility on menu click
//   const handleMenuClick = () => {
//     setSidebarOpen(!isSidebarOpen);
//   };

//   // Handles profile click event (add functionality later if needed)
//   const handleProfileClick = () => {
//     // Add profile-related logic here
//   };

//   return (
//     <Box sx={{ display: 'flex', minHeight: '100vh' }}>
//       <CssBaseline />

//       {/* Sidebar Component */}
//       <Sidebar
//         open={isSidebarOpen}
//         onClose={() => setSidebarOpen(false)}
//       />

//       <Box
//         sx={{
//           flexGrow: 1,
//           display: 'flex',
//           flexDirection: 'column',
//           justifyContent: 'flex-start',
//         }}
//       >
//         {/* Header Component */}
//         <Header
//           edit={false}
//           onMenuClick={handleMenuClick}
//           handleProfileClick={handleProfileClick}
//           isMobile={isMobile}
//           setSidebarOpen={setSidebarOpen}
//           isSidebarOpen={isSidebarOpen}
//           icon={<FaUsersGear />}
//           headerName={headerName}
//         />

//         <Box
//           component="main"
//           sx={{
//             flexGrow: 1,
//             p: 2.5,
//             backgroundColor: '#F7F7F7',

//           }}
//         >

//           <Routes>
//             <Route path="/" element={<Dashboard />} />

//             {/* Protected routes */}
//             <Route
//               path="/registration-approval"
//               element={
//                 <ProtectedRoute permission="view_registration_approval">
//                   <RegistrationApproval />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="/alluserlist"
//               element={
//                 <ProtectedRoute permission="view_user_management">
//                   <AllUserList />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="/reports"
//               element={
//                 <ProtectedRoute permission="view_reports">
//                   <UserRole />
//                 </ProtectedRoute>
//               }
//             />
//             {/* <Route path="*" element={<Navigate to="/dashboard" />} /> */}
//           </Routes>

//           {/* Main Content */}
//           {/* <Routes>
//             <Route
//               path="/"
//               element={<ProtectedRoute element={<Dashboard setHeaderName={setHeaderName} />} />}
//             />
//             <Route
//               path="/alluserlist"
//               element={<ProtectedRoute element={<AllUserList />} />}
//             />
//             <Route
//               path="/purchaserlist"
//               element={<ProtectedRoute element={<PurchaserList />} />}
//             />
//             <Route
//               path="/referrerlist"
//               element={<ProtectedRoute element={<ReferrerList />} />}
//             />
//             <Route
//               path="/finanicalconsultantlist"
//               element={<ProtectedRoute element={<FinanicalConsultantList />} />}
//             />
//             <Route
//               path="/ContentManagement-home"
//               element={<ProtectedRoute element={<ContentManagement />} />}
//             />
//             <Route
//               path="/ContentManagement-stakenow"
//               element={<ProtectedRoute element={<StakeNowContentManagement />} />}
//             />
//             <Route
//               path="/user-role"
//               element={<ProtectedRoute element={<UserRole />} />}
//             />
//             <Route
//               path="/user-list"
//               element={<ProtectedRoute element={<UserList />} />}
//             />
//              <Route
//               path="/Registration-Approval"
//               element={<ProtectedRoute element={<RegistrationApproval />} />}
//             />

//         </Routes> */}
//         </Box>

//         {/* Footer Component (Optional) */}
//         {/* <FooterPage /> */}
//       </Box>
//     </Box >
//   );
// };

// export default Layout;

import React, { useState } from "react";
import {
  Box,
  CssBaseline,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Routes, Route } from "react-router-dom";
import Sidebar from "../SideNav/Sidebar";
import Header from "../SideNav/Header";
import Dashboard from "../../Pages/Dashboard/Dashboard";
import AllUserList from "../../Pages/OperatorRegistration/AllUserList";
import RegistrationApproval from "../../Pages/Management/RegistrationApproval/RegistrationApproval";
import ProtectedRoute from "../../Pages/PrivateRoute";
import PurchaserList from "../../Pages/OperatorRegistration/PurchaserList";
import ReferrerList from "../../Pages/OperatorRegistration/ReferrerList";
import FinanicalConsultantList from "../../Pages/OperatorRegistration/FinanicalConsultantList";
import UserRole from "../../Pages/Masters/UserRole/UserRole";
import UserList from "../../Pages/Masters/UserList/UserList";
import ContentManagement from "../../Pages/ContentManagement/Home/ContentManagement";
import StakeNowContentManagement from "../../Pages/ContentManagement/StakeNow/StakeNowContentManagement";
import OperatorDashboard from "../../Pages/Operator/OperatorDashboard/OperatorDashboard";
import { useSelector } from "react-redux";
import UserRegistration from "../../Pages/Operator/UserRegistration/UserRegistration";
import TotalOnboarding from "../../Pages/Operator/OperatorDashboard/TotalOnboarding";
import TotalRegistrationTabComponent from "../../Pages/Operator/OperatorDashboard/TotalRegistration/TotalRegistrationTabComponent";
import TotalPaymentReceivedTabs from "../../Pages/Operator/OperatorDashboard/TotalPaymentReceived/TotalPaymentReceivedTabs";
import TotalTransactionCompleteTabs from "../../Pages/Operator/OperatorDashboard/TotalTransactionComplete/TotalTransactionCompleteTabs";
import SchemeManagement from "../../Pages/SchemeManagement/GoldStakeScheme/SchemeManagement";
import ReferralsSchemeTabs from "../../Pages/SchemeManagement/ReferralsScheme/ReferralsSchemeTabs";
import TotalPurchaseForUsers from "../../Pages/Operator/OperatorDashboard/TotalPurchaseForUsers/TotalPurchaseForUsers";
import TotalCashPaymentReceived from "../../Pages/Operator/OperatorDashboard/TotalPaymentReceived/TotalCashPaymentReceived";
import TotalNetBankingPaymentReceived from "../../Pages/Operator/OperatorDashboard/TotalPaymentReceived/TotalNetBankingPaymentReceived";
import PurchaseApprovalApproved from "../../Pages/Management/PurchaseApproval/PurchaseApprovalApproved";
import PurchaseApprovalTabs from "../../Pages/Management/PurchaseApproval/PurchaseApprovalTabs";
import SchemeApprovalTabs from "../../Pages/Management/SchemeApproval/GoldStakeSchemeApproval/SchemeApprovalTabs";
import ReferralsSchemeApprovalTabs from "../../Pages/Management/SchemeApproval/ReferralsSchemeApproval/ReferralsSchemeApprovalTabs";
// import Referrals from "../../Pages/ContentManagement/Referrals/Referrals/Referrals";
import ReferralsContentManagement from "../../Pages/ContentManagement/Referrals/ReferralsContentManagement";
import AboutUsContentManagement from "../../Pages/ContentManagement/AboutUs/AboutUsContentManagement";
import BlogsContentManagement from "../../Pages/ContentManagement/Blogs/BlogsContentManagement";
import ContactUsContentManagement from "../../Pages/ContentManagement/ContactUs/ContactUsContentManagement";
import AddCountry from "../../Pages/Masters/AddCountry/AddCountry";
import WithdrawForSacnQR from "../../Pages/Masters/ScanQR/WithdrawForSacnQR";
// import AboutUsManagementAboutUsContentManagement from "../../Pages/ContentManagement/AboutUs/AboutUsContentManagement";
// import SchemeApprovalTabs from "../../Pages/Management/SchemeApproval/SchemeApprovalTabs";

const Layout = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  // const { isLoggedIn, permissions, role } = useSelector((state) => state.auth);
  const [headerTitleName, setHeaderTitleName] = useState("");
  const handleMenuClick = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const role = sessionStorage.getItem("role")
  console.log(role, "roleeeeeeeee");

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        padding: { md: 1.5 },
        backgroundColor: "#F7F7F7",
      }}
    >
      <CssBaseline />
      {/* <Sidebar open={isSidebarOpen} onClose={() => setSidebarOpen(false)} /> */}
      <Sidebar open={isSidebarOpen} onClose={() => setSidebarOpen(false)} />
      <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
        <Header
          headerTitleName={headerTitleName}
          onMenuClick={handleMenuClick}
          isMobile={isMobile}
          isSidebarOpen={isSidebarOpen}
        />
        <Box
          component="main"
          sx={{ flexGrow: 1, p: 2.5, backgroundColor: "#F7F7F7" }}
        >
          {/* <Typography variant='hello'>hello</Typography> */}

          <Routes>
            {/* <Route path="/" element={<Dashboard />} />
            <Route
              path="/registration-approval"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <RegistrationApproval />
                </ProtectedRoute>
              }
            />
            <Route
              path="/alluserlist"
              element={
                <ProtectedRoute permission="view_user_management">
                  <AllUserList />
                </ProtectedRoute>
              }
            /> */}
            {/* <Route
              path="/"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  {role === "operator" ? (
                    <OperatorDashboard
                      setHeaderTitleName={setHeaderTitleName}
                    />
                  ) : (
                    <Dashboard setHeaderTitleName={setHeaderTitleName} />
                  )}
                </ProtectedRoute>
              }
            /> */}
            {/* <Routes> */}
            {role === "operator" ? (
              <Route
                path="/"
                element={<ProtectedRoute module="Dashboard" page="Dashboard" action="view" />}
              >
                <Route index element={<OperatorDashboard />} />
              </Route>) :
              (<Route
                path="/"
                element={<ProtectedRoute module="Dashboard" page="Dashboard" action="view" />}
              >
                <Route index element={<Dashboard />} />
              </Route>)}
            {/* </Routes> */}
            {/* 
            <Route
                path="/"
                element={<ProtectedRoute module="Dashboard" page="Dashboard" action="view" />}
              >
                <Route index element={<Dashboard />} />
              </Route> */}
            {/* <Route
              path="/alluserlist"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <AllUserList setHeaderTitleName={setHeaderTitleName} />
                </ProtectedRoute>
              }
            /> */}

            <Route
              path="/alluserlist"
              element={<ProtectedRoute module="OperatorRegistration" page="All User List" action="view" />}
            >
              <Route index element={<AllUserList />} />
            </Route>

            <Route
              path="/purchaserlist"
              element={<ProtectedRoute module="OperatorRegistration" page="Purchaser List" action="view" />}
            >
              <Route index element={<PurchaserList />} />
            </Route>

            <Route
              path="/referrerlist"
              element={<ProtectedRoute module="OperatorRegistration" page="Referrer List" action="view" />}
            >
              <Route index element={<ReferrerList />} />
            </Route>

            <Route
              path="/finanicalconsultantlist"
              element={<ProtectedRoute module="OperatorRegistration" page="Financial Consultant List" action="view" />}
            >
              <Route index element={<FinanicalConsultantList />} />
            </Route>

            {/* <Route
              path="/purchaserlist"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <PurchaserList setHeaderTitleName={setHeaderTitleName} />
                </ProtectedRoute>
              }
            /> */}
            {/* <Route
              path="/referrerlist"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <ReferrerList setHeaderTitleName={setHeaderTitleName} />
                </ProtectedRoute>
              }
            /> */}
            {/* <Route
              path="/finanicalconsultantlist"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <FinanicalConsultantList
                    setHeaderTitleName={setHeaderTitleName}
                  />
                </ProtectedRoute>
              }
            /> */}

            <Route
              path="/contentmanagement-home"
              element={<ProtectedRoute module="ContentManagement" page="Home" action="view" />}
            >
              <Route index element={<ContentManagement />} />
            </Route>
            <Route
              path="/contentmanagement-stakenow"
              element={<ProtectedRoute module="ContentManagement" page="Stake Now" action="view" />}
            >
              <Route index element={<StakeNowContentManagement />} />
            </Route>
            <Route
              path="/contentmanagement-referrals"
              element={<ProtectedRoute module="ContentManagement" page="Referrals" action="view" />}
            >
              <Route index element={<ReferralsContentManagement />} />
            </Route>
            <Route
              path="/contentmanagement-aboutus"
              element={<ProtectedRoute module="ContentManagement" page="About Us" action="view" />}
            >
              <Route index element={<AboutUsContentManagement />} />
            </Route>
            <Route
              path="/contentmanagement-blogs"
              element={<ProtectedRoute module="ContentManagement" page="Blog" action="view" />}
            >
              <Route index element={<BlogsContentManagement />} />
            </Route>
            <Route
              path="/contentmanagement-contactus"
              element={<ProtectedRoute module="ContentManagement" page="Contact Us" action="view" />}
            >
              <Route index element={<ContactUsContentManagement />} />
            </Route>
            {/* <Route
              path="/contentmanagement-home"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <ContentManagement setHeaderTitleName={setHeaderTitleName} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contentmanagement-stakenow"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <StakeNowContentManagement
                    setHeaderTitleName={setHeaderTitleName}
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contentmanagement-referrals"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <ReferralsContentManagement
                    setHeaderTitleName={setHeaderTitleName}
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contentmanagement-aboutus"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <AboutUsContentManagement
                    setHeaderTitleName={setHeaderTitleName}
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contentmanagement-blogs"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <BlogsContentManagement
                    setHeaderTitleName={setHeaderTitleName}
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contentmanagement-blogs"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <BlogsContentManagement
                    setHeaderTitleName={setHeaderTitleName}
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contentmanagement-contactus"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <ContactUsContentManagement
                    setHeaderTitleName={setHeaderTitleName}
                  />
                </ProtectedRoute>
              }
            /> */}


            <Route
              path="/user-role"
              element={<ProtectedRoute
              // module="ContentManagement" page="Contact Us" action="view"
              // allowedRoles={["superAdmin"]}
              />}
            >
              <Route index element={<UserRole />} />
            </Route>

            <Route
              path="/user-list"
              element={<ProtectedRoute />}
            >
              <Route index element={<UserList />} />
            </Route>

            <Route
              path="/add-country"
              element={<ProtectedRoute />}
            >
              <Route index element={<AddCountry />} />
            </Route>

            <Route
              path="/Scan-qr"
              element={<ProtectedRoute />}
            >
              <Route index element={<WithdrawForSacnQR />} />
            </Route>


            {/* <Route
              path="/user-role"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <UserRole setHeaderTitleName={setHeaderTitleName} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/user-list"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <UserList setHeaderTitleName={setHeaderTitleName} />
                </ProtectedRoute>
              }
            /> */}
            <Route
              path="/registration-approval"
              element={<ProtectedRoute />}
            >
              <Route index element={<RegistrationApproval />} />
            </Route>

            {/* <Route
              path="/registration-approval"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <RegistrationApproval
                    setHeaderTitleName={setHeaderTitleName}
                  />
                </ProtectedRoute>
              }
            /> */}

            <Route
              path="/user-registration"
              element={<ProtectedRoute />}
            >
              <Route index element={<UserRegistration />} />
            </Route>


            {/* <Route
              path="/user-registration"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <UserRegistration setHeaderTitleName={setHeaderTitleName} />
                </ProtectedRoute>
              }
            /> */}

            <Route
              path="/purchase-approval"
              element={<ProtectedRoute />}
            >
              <Route index element={<PurchaseApprovalTabs />} />
            </Route>

            {/* <Route
              path="/purchase-approval"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <ReferralsSchemeApprovalTabs
                    setHeaderTitleName={setHeaderTitleName}
                  />
                </ProtectedRoute>
              }
            /> */}


            <Route
              path="/goldstakescheme-approval"
              element={<ProtectedRoute />}
            >
              <Route index element={<SchemeApprovalTabs />} />
            </Route>

            <Route
              path="/referralscheme-approval"
              element={<ProtectedRoute />}
            >
              <Route index element={<ReferralsSchemeApprovalTabs />} />
            </Route>
            {/* <Route
              path="/goldstakescheme-approval"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <SchemeApprovalTabs setHeaderTitleName={setHeaderTitleName} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/referralscheme-approval"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <ReferralsSchemeApprovalTabs
                    setHeaderTitleName={setHeaderTitleName}
                  />
                </ProtectedRoute>
              }
            /> */}

            <Route
              path="/total-onboarding"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <TotalOnboarding setHeaderTitleName={setHeaderTitleName} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/total-regisration"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <TotalRegistrationTabComponent
                    setHeaderTitleName={setHeaderTitleName}
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/total-paymentreceived"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <TotalPaymentReceivedTabs
                    setHeaderTitleName={setHeaderTitleName}
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/total-transaction-complete"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <TotalTransactionCompleteTabs
                    setHeaderTitleName={setHeaderTitleName}
                  />
                </ProtectedRoute>
              }
            />


            {/* <Route
              path="/scheme-management"
              element={<ProtectedRoute module="ContentManagement" page="Contact Us" action="view" />}
            >
              <Route index element={<SchemeManagement />} />
            </Route> */}

            <Route
              path="/referrals-schemes"
            >
              <Route index element={<ReferralsSchemeTabs />} />
            </Route>
            <Route
              path="/scheme-management"
              // element={<ProtectedRoute module="SchemeManagement" page="Gold Stake Schemes" action="view" />}
              element={<ProtectedRoute module="SchemeManagement" page="Gold Stake Schemes" action="view" />}

            >
              <Route index element={<SchemeManagement />} />
            </Route>
            {/* <Route
              path="/referrals-schemes"
              element={<ProtectedRoute module="OperatorRegistration" page="Referral Schemes" action="view" />}
            >
              <Route index element={<ReferralsSchemeTabs />} />
            </Route> */}
            {/* <Route
              path="/scheme-management"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <SchemeManagement setHeaderTitleName={setHeaderTitleName} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/referrals-schemes"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <ReferralsSchemeTabs
                    setHeaderTitleName={setHeaderTitleName}
                  />
                </ProtectedRoute>
              }
            /> */}
            <Route
              path="/total-onboarding"
              element={<ProtectedRoute />}
            >
              <Route index element={<TotalOnboarding />} />
            </Route>

            <Route
              path="/total-purchase-users"
              element={<ProtectedRoute />}
            >
              <Route index element={<TotalPurchaseForUsers />} />
            </Route>

            <Route
              path="/total-cashpaymentreceived"
              element={<ProtectedRoute />}
            >
              <Route index element={<TotalCashPaymentReceived />} />
            </Route>

            <Route
              path="/total-netbankingpaymentreceived"
              element={<ProtectedRoute />}
            >
              <Route index element={<TotalNetBankingPaymentReceived />} />
            </Route>

            {/* <Route
              path="/total-purchase-users"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <TotalPurchaseForUsers
                    setHeaderTitleName={setHeaderTitleName}
                  />
                </ProtectedRoute>
              }
            /> */}
            {/* <Route
              path="/total-cashpaymentreceived"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <TotalCashPaymentReceived
                    setHeaderTitleName={setHeaderTitleName}
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/total-netbankingpaymentreceived"
              element={
                <ProtectedRoute permission="view_registration_approval">
                  <TotalNetBankingPaymentReceived
                    setHeaderTitleName={setHeaderTitleName}
                  />
                </ProtectedRoute>
              }
            /> */}
          </Routes>
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
